export const slides = {
  hy: [
    "Հարց 1․ Ի՞նչ է «Ազգային կրթական համակարգը»․",
    "Հարց 2․ Ինչո՞վ է թելադրված «Ազգային կրթական համակարգի» ստեղծման անհրաժեշտությունը․",
    "Հարց 3․ Ովքե՞ր են «Ազգային կրթական համակարգի» պատասխանատվություն ստանձնողները և իրականացողները․",
    "Հարց 4․ Ո՞րն է «Ազգային կրթակարգի» ստեղծման բուն նպատակը․",
    "Հարց 5․ Ովքե՞ր են լինելու «Ազգային կրթական համակարգի» իրական շահառուները․",
    "Հարց 6․ Ի՞նչ ֆորմալ հիմք ունի «Ազգային կրթական համակարգը»․",
    "Հարց 7․ «Ազգային կրթական համակարգը» հասարակական աջակցության ինչպիսի՞ ակնկալիք ունի և ո՞ր շերտերից։",
  ],
  en: [
    "Question 1: What is the 'National Education System'?",
    "Question 2: Why is the creation of the 'National Education System' necessary?",
    "Question 3: Who are the responsible parties and implementers of the 'National Education System'?",
    "Question 4: What is the main purpose of creating the 'National Curriculum'?",
    "Question 5: Who will be the real beneficiaries of the 'National Education System'?",
    "Question 6: What formal basis does the 'National Education System' have?",
    "Question 7: What kind of public support does the 'National Education System' expect, and from which social groups?",
  ],
};
